import ContactBadge from './contact-badge';

export default ContactBadge;
